import React, { useEffect, useState } from 'react';
import { CForm, CFormLabel, CFormInput, CButton, CListGroup, CListGroupItem, CFormCheck, CFormTextarea } from '@coreui/react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import DangerWorks from './DangerWorks';
import ResponsibleForLaborProtection from './ResponsibleForLaborProtection';
import WorkSchedule from './WorkSchedule';
import ProtocolOP from './ProtocolOP';
import JobWorkers from './JobWorkers';
import JobData from './JobData';
import { confirmAlert } from 'react-confirm-alert';
import AxiosInstance from 'src/components/Axios';
// import AdditionalMaterials from './AdditionalMaterials';
import ButtonsBlock from './ButtonsBlock';
import WarningWhenChecked from './WarningWhenChecked';
import JobSpecialMachines from './JobSpecialMachines';
import dayjs from 'dayjs';
// import AdditionalInstruments from './AdditionalInstruments/AdditionalInstruments';
import { toast, ToastContainer } from 'react-toastify'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import { FaUserCog } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { MdEngineering } from "react-icons/md";
import { MdWarningAmber } from "react-icons/md";
import { FaTractor } from "react-icons/fa";

import { FaHardHat, FaBoxes, FaTools } from "react-icons/fa";
import css from "./AdditionalInstruments/AdditionalInstruments.module.scss"
// bulk print посвідчень: ReactDOM для рендеру карток в iframe, PrintWorkerCard — компонент картки
import ReactDOM from 'react-dom/client'
import PrintWorkerCard from 'src/views/workers/PrintWorkerCard'







// Компонент для існуючої роботи
const ExistJobForm = (props) => {
    // console.log('ExistJobForm props', props);

    const urlApi = '/jobs'
    const urlRouter = '/jobs'
    const urlMedia = '/media_objects'
    const urlApiEngineers = '/engineers'
    const toolsUrl = '/job_tools'
    const utcNow = dayjs().toISOString()
    // токен
    const tokenStr = localStorage.getItem('user')
    const header = { headers: { Authorization: `Bearer ${tokenStr}`, accept: 'application/json' } }

    // id користувача
    const us = localStorage.getItem('user_data')
    const role = localStorage.getItem('user_role')

    const navigate = useNavigate()

    const [commandmentState, setCommandmentState] = useState(null)
    const [graphState, setGraphState] = useState(null)
    const [dataState, setDataState] = useState(props.data)
    const [myDataState, setMyDataState] = useState(props.data)
    const [protocoleState, setProtocoleState] = useState(null)
    const [jobWorkers, setJobWorkers] = useState(props.data != undefined ? props.data.jobWorkers : [])
    const [isChecked, setIsChecked] = useState(props.data?.AccountJobsList ? true : false)
    const [accJobsList, setAccJobsList] = useState(
        props.data?.AccountJobsList ? [...props.data.AccountJobsList] : [],
    )
    // Блокувати можливу зміну даних, якщо data.status === "checked"
    const [isDisabledChange, setIsDisabledChange] = useState(false)
    // Чи відправити документи на перевірку Адміну
    const [isSendForInspection, setIsSendForInspection] = useState(false)
    const [isDisabledSend, setIsDisabledSend] = useState(false)
    // Зауваження від адміністратора до доданих файлів
    const [comentar, setComentar] = useState(dataState?.comentar ? dataState.comentar : "");
    // Заблокувати можливу зміну, оскільки дані вже вневені в 1С
    const [isDisabledAll, setIsDisabledAll] = useState(false);

    // Відкрити/закрити вікно з попередженням про зміну status="checked" (або statusMainEngineerOp) - можливі подальші зміни тільки в 1С
    const [openWarning, setOpenWarning] = useState(false);
    const [openWarningForEngineer, setOpenWarningForEngineer] = useState(false);
    const [openWarningForMainEngineerOp, setOpenWarningForMainEngineerOp] = useState(false);
    const [userRoleForWarningModal, setUserRoleForWarningModal] = useState(null);

    //стани для додаткових інструментів
    const [blocks, setBlocks] = useState([0]);
    //загальний список інструментів
    const [toolsList, setToolsList] = useState([])
    //список інструментів привязаний до роботи
    const [jobTools, setJobTools] = useState([])
    //вибраний інструмент
    const [selectedTool, setSelectedTool] = useState(null);
    //стан для зберігання коментів
    const [coment, setComent] = useState({})
    //стан для інпута назви інструмента
    const [toolName, setToolName] = useState('')
    //стан для інпута номера інструмента
    const [toolNumber, setToolNumber] = useState('')

    //стани для пошуку
    const [searchResults, setSearchResults] = useState([])
    //стан для показу результатів
    const [showResults, setShowResults] = useState(false);
    //Стан для інфо для друку карток працівників
    const [printWorkersData, setPrintWorkersData] = useState([])



    const popupTextDocumentSuccess = "Дані оновлено";
    const popupTextAddFileSuccess = "Файл додано";
    const popupTextDeleteFileSuccess = 'Файл видалено';
    const popupTextAddComentarSuccess = "Зауваження додано";

    // useEffect(() => {
    //     console.log('props.data.status', props.data.status);
    //     console.log('dataState.status', dataState.status);
    //     console.log('isDisabledChange', isDisabledChange);
    //     console.log('isSendForInspection', isSendForInspection);
    //     console.log('isDisabledSend', isDisabledSend);
    // }, [props.data.status, isDisabledChange, isSendForInspection, isDisabledSend, dataState]);
    console.log('myDataState', myDataState)

    const [file, setFile] = useState(null)
    // const [arrFile, setArrFile] = useState(props.data ? [...props.data.mediaObjects] : [])
    const [arrFile, setArrFile] = useState(dataState ? [...dataState.mediaObjects] : [])

    // Блокувати можливу зміну даних, якщо data.status === "checked"
    // Чи відправлено на перевірку
    useEffect(() => {
        // console.log('dataState', dataState);

        if (dataState != undefined && (dataState?.status === "new")) {
            setIsDisabledChange(false);
            setIsSendForInspection(false);
        }

        if (dataState != undefined && dataState?.status === "not_checked") {
            setIsDisabledChange(true);
            setIsSendForInspection(true);
        }

        if (dataState != undefined && (dataState?.status === "rejected")) {
            setIsDisabledChange(true);
            setIsSendForInspection(true);
        }

        // Заблокувати можливу зміну, оскільки дані вже вневені в 1С
        if (dataState != undefined && (dataState?.status === "synced" || dataState?.status === "checked")) {
            setIsDisabledAll(true);
        }


        // Оновити Зауваження (коментар) для доданих файлів
        setComentar(dataState?.comentar ? dataState.comentar : "");
    }, [dataState]);


    // Відслідковувати зміну наявних документів, чи відправити документи на перевірку Адміну
    useEffect(() => {
        if (myDataState != undefined && myDataState.commandment != undefined && myDataState.graph != undefined && myDataState.protocole != undefined) {
            // setIsSendForInspection(true)
            setIsDisabledSend(false)
        } else {
            // setIsSendForInspection(false)
            setIsDisabledSend(true)
        }
    }, [myDataState, myDataState.commandment, myDataState.graph, myDataState.protocole])


    // useEffect(() => {
    //   console.log('selectedOptionEngineers', selectedOptionEngineers)
    // }, [selectedOptionEngineers])


    // Відслідковувати які дані підставляти в модальне вікно з попередженням
    useEffect(() => {
        if (openWarningForEngineer) {
            setUserRoleForWarningModal("Engineer");
            setOpenWarning(true);
        };
        if (openWarningForMainEngineerOp) {
            setUserRoleForWarningModal("MainEngineerOp");
            setOpenWarning(true);
        };
    }, [openWarningForEngineer, openWarningForMainEngineerOp]);

    // Функція для запиту за даними про роботу
    const getData = () => {
        AxiosInstance.get(`${urlApi}/${props.data.id}`, { headers: { accept: 'application/json' } }).then((response) => {
            // console.log('get data response.data', response.data);
            setJobWorkers(response.data.jobWorkers);
            setDataState(response.data)

            response.data.AccountJobsList ? setAccJobsList(response.data.AccountJobsList) : null
            setAccJobsList(response.data.AccountJobsList)
        },
        )
    }


    // useEffect(() => {
    //   loadOptionsPartners();
    // }, [userId])


    // // додавання файлів
    // const handleFileChange = (event) => {
    //   const myFile = event.target.files[0]

    //   setFile(myFile)
    // }


    // додавання файлів обов`язкових
    const handleFileChangeState = (event, setState) => {
        const myFile = event.target.files[0]
        setState(myFile)
    }


    // відправити файл
    const handleSubmitAddFile = async (e) => {
        e.preventDefault()

        try {
            // Створити URL для відправки файлу
            const url = process.env.REACT_APP_SERVER_URL + '/api/media_objects?job=' + props.data.id

            // формуємо файл
            if (file) {
                const formData = new FormData()
                formData.append('file', file)
                formData.append('name', file.name)
                formData.append('job', props.data.id)

                // Відправити файл
                const responseFile = await AxiosInstance.post(url, formData, header)

                // Повідомлення про успішне додавання файлу
                props.popup.toastifySuccess(popupTextAddFileSuccess)
            }

            // Отримати оновлені дані після завантаження файлу
            const responseUpdatedData = await AxiosInstance.get(`${urlApi}/${props.data.id}`, header)

            setArrFile([...responseUpdatedData.data.mediaObjects])
        } catch (error) {
            console.error('Сталася помилка під час обробки запиту', error)
        }
    }

    // console.log('arrFile', arrFile);

    // Функція для видалення доданих файлів
    const deleteFile = async (object, name) => {
        // console.log('object', object);
        // console.log('name', name);

        let dataToUpdate;

        if (name !== "additionalMaterials") {
            // Для protocole, graph, commandment
            dataToUpdate = {
                [name]: null,
                status: 'new',
            };
        }

        // console.log('dataToUpdate', dataToUpdate)

        try {
            await confirmAlert({
                title: 'Ви впевнені що хочите видалити цей пункт ?',
                message: 'Are you sure to do this.',
                buttons: [
                    {
                        label: 'Так',
                        onClick: async () => {
                            if (name === "additionalMaterials") {
                                await AxiosInstance.delete(`${urlMedia}/${object.id}`, header).then(() => {
                                    // console.log('файл видалено')
                                    // Повідомлення про успішне видалення файлу
                                    props.popup.toastifySuccess(popupTextDeleteFileSuccess)

                                    // Отримання оновлених даних після видалення файлу
                                    AxiosInstance.get(`${urlApi}/${props.data.id}`, header).then((response) => {
                                        if (response.status === 200) {
                                            setArrFile([...response.data.mediaObjects])
                                            setMyDataState(response.data)
                                        } else {
                                            console.log("Помилка оновлення даних");
                                        }
                                    })
                                })
                                    .catch((error) => {
                                        console.error('Помилка видалення:', error)
                                    })

                            } else {
                                await AxiosInstance.put(`${urlApi}/${dataState.id}`, dataToUpdate, header).then((response) => {
                                    // console.log('response', response);
                                    if (response.status === 200) {
                                        // Видалення файлу зображення
                                        AxiosInstance.delete(`${urlMedia}/${object.id}`, header)
                                            .then((response) => {
                                                // console.log('файл видалено')
                                            })
                                            .catch((error) => {
                                                console.error('Помилка видалення:', error)
                                            })
                                    }
                                })

                                // Повідомлення про успішне видалення файлу
                                props.popup.toastifySuccess(popupTextDeleteFileSuccess)
                                // Отримання оновлених даних після видалення файлу
                                const response = await AxiosInstance.get(`${urlApi}/${props.data.id}`, header)
                                // console.log('response3234242344', response.data)
                                setArrFile([...response.data.mediaObjects])
                                setMyDataState(response.data)
                            }
                        },
                    },
                    {
                        label: 'Ні',
                        onClick: () => {
                            return
                        },
                    },
                ],
            })
        } catch (error) {
            console.error('Помилка видалення:', error)
        }
    }


    const handleCheckboxChange = () => {
        setIsChecked(!isChecked)
    }


    // додаємо файл
    const handleAddFile = async (dataState, keyInObject, urlApi) => {
        try {
            // Створити URL для відправки файлу з фото
            const url = process.env.REACT_APP_SERVER_URL + '/api/media_objects'

            const response1 = await AxiosInstance.get(`${urlApi}/${props.data.id}`, header)
            // console.log('response1', response1.data[keyInObject].id)

            if (dataState) {
                const formData = new FormData()
                formData.append('file', dataState)
                formData.append('name', dataState.name)

                // Відправити файл у базу
                const responseAddFile = await AxiosInstance.post(url, formData, header)
                // console.log('responseAddFile', responseAddFile)

                // Зв'язуємо файл із URL
                if (responseAddFile.status === 201) {
                    const data_response = {
                        [keyInObject]: `/api/media_objects/${responseAddFile.data.id}`,
                        //1 зміна
                        dateModified: utcNow
                    }

                    const responseAddNewFile = await AxiosInstance.patch(
                        `${urlApi}/${props.data.id}`,
                        data_response,
                        header,
                    )

                    if (response1.data[keyInObject]?.id) {
                        const deleteOldData = AxiosInstance.delete(
                            `${url}/${response1.data[keyInObject].id}`,
                            header,
                        )
                    }

                    // Повідомлення про успішне додавання файлу
                    props.popup.toastifySuccess(popupTextAddFileSuccess);

                    // Отримати оновлені дані після завантаження файлу
                    const responseUpdatedData = await AxiosInstance.get(`${urlApi}/${props.data?.id}`, header)
                    setMyDataState(responseUpdatedData.data)
                }
            }
        } catch (error) {
            console.error('Сталася помилка під час обробки запиту', error)
        }
    }


    // Функція для зміни статуса (вкладені документи)
    const changeStatus = async (newStatus) => {
        // console.log('newStatus', newStatus);
        let data_response = {};
        if (newStatus?.status === "checked") {
            data_response = {
                status: newStatus.status,
                comentar: "",
                assignedUser: `/api/users/${props.assignedUserId}`,
                dateAudit: props.currentDate.toISOString(),
                //2 зміна
                dateModified: utcNow
            };
        } else if (newStatus?.status === "not_checked") {
            data_response = {
                status: newStatus.status,
                dateStartAudit: props.currentDate.toISOString(),
                //3 зміна
                dateModified: utcNow
            };
        } else if (newStatus?.status === "new") {
            data_response = {
                status: newStatus.status,
                dateStartAudit: null,
                statusMainEngineerOp: null,
                mainEngineerOp: null,
                dateMainEngineerOp: null,
                //4 зміна
                dateModified: utcNow
            };
        } else {
            data_response = {
                status: newStatus.status,
                //5 зміна
                dateModified: utcNow
            };
        };

        if (newStatus?.statusMainEngineerOp === "checked") {
            data_response = {
                statusMainEngineerOp: newStatus.statusMainEngineerOp,
                mainEngineerOp: `/api/users/${props.assignedUserId}`,
                dateMainEngineerOp: props.currentDate.toISOString(),
                //6 зміна
                dateModified: utcNow
            };
        };

        // console.log('status data_response', data_response);

        try {
            await AxiosInstance.put(`${urlApi}/${props.data.id}`, data_response, header);
            // console.log('response', response);
            props.popup.toastifySuccess(popupTextDocumentSuccess);
            // Оновити дані
            getData();
        } catch (error) {
            console.error('Помилка під час виконання запиту', error);
        };
    };

    // Функція для зміни зауваження до доданих файлів (вкладені документи)
    const addComentar = async (comentar) => {
        // console.log('comentar', comentar);
        const data_response = {
            comentar: comentar,
            status: "rejected",
            //7 зміна
            dateModified: utcNow
        };
        // console.log('comentar data_response', data_response);
        try {
            await AxiosInstance.put(`${urlApi}/${props.data.id}`, data_response, header);
            // console.log('response', response);
            props.popup.toastifySuccess(popupTextAddComentarSuccess);
            getData();
        } catch (error) {
            console.error('Помилка під час виконання запиту', error);
        }
    };


    // Функція для закриття модального вікна з попередженням та очищення даних для модального вікна
    const handleCloseWarning = () => {
        // Закрити модальне з попередженням
        setOpenWarning(false);
        // Очистити дані для модального вікна
        setOpenWarningForEngineer(false);
        setOpenWarningForMainEngineerOp(false);
        setUserRoleForWarningModal(null);
    };


    // логіка для отримання професій працівника привязаних до роботи 

    const jobToolsList = async () => {
        try {

            const response = await AxiosInstance.get(`/job_tools?job.id=${dataState.id}`);
            const tools = response.data['hydra:member'];

            //залишив зразок ,якщо треба буде сортувати в майбутньому
            // //сортування для впевненості,якщо не буде вертати з апі в порядку зростання id
            // const sortedProfessions = professions?.map((item) => {
            //     //щоб нові доки були вкінці
            //     const sortedDocs = [...item.workerProffesionDocs].sort((a, b) => a.id - b.id);
            //     //щоб нові доки були спочатку
            //     // const sortedDocs = [...item.workerProffesionDocs].sort((a, b) => b.id - a.id);


            //     return {
            //         ...item,
            //         workerProffesionDocs: sortedDocs,
            //     };

            // })

            // console.log('tools', tools)
            //залишив зразок на випадок ,якщо не будуть розгортатись поля
            // const detailedProfessions = await Promise.all(
            //   professions.map(async (item) => {

            //     let professionData = null;
            //     let docsData = []
            //     if (item.proffesion && typeof item.proffesion === "string") {
            //       const res = await AxiosInstance.get(`worker_proffession_lists?workerProffessions.id=${item.id}`);
            //       professionData = res.data['hydra:member'][0];
            //     }
            //     if (item.workerProffesionDocs && item.workerProffesionDocs.length > 0

            //     ) {
            //       const res = await AxiosInstance.get(`worker_proffession_docs?workerProffesion.id=${item.id}`);
            //       docsData = res.data['hydra:member'];
            //     }


            //     return {
            //       ...item,
            //       workerProfessionsList: professionData || item.proffesion,
            //       workerProffesionDocs: docsData || item.workerProffesionDocs
            //     };
            //   })
            // );


            // setWorkerProfessions(detailedProfessions);

            // setJobTools(sortedProfessions)
            setJobTools(tools)
        } catch (error) {
            console.error("Помилка при завантаженні професій:", error);
        }
    }

    // логіка для отримання професій працівника з jobToolsList
    const contragentToolsList = async () => {
        try {

            const response = await AxiosInstance.get(`/job_tools_lists`);
            const tools = response.data['hydra:member'];

            // Фільтруємо лише ті, що належать конкретному account
            const filteredTools = tools.filter(
                (tool) => tool.account.id === dataState.account.id
                //  `/api/accounts/${dataState.account.id}`
            );

            // setToolsList(tools)
            setToolsList(filteredTools)
        } catch (error) {
            console.error("Помилка при завантаженні професій:", error);
        }
    }


    //блок для додавання інструментів
    // const loadToolsOptions = async () => {
    //     try {
    //         const response = await AxiosInstance.get(`/job_tools_lists`);
    //         const allOptions = response.data['hydra:member'];

    //         // console.log('allOptions', allOptions)

    //         // const filtered = allOptions.filter(opt => {
    //         //   return !workerProfessions.some(p => {
    //         //     if (p.workerProffessionList && typeof p.workerProffessionList === 'object') {
    //         //       return p.workerProffessionList.id === opt.id;
    //         //     }
    //         //     return false;
    //         //   });
    //         // });
    //         // console.log('filtered', filtered)

    //         // const options = filtered.map(job => ({
    //         //   label: job.name,
    //         //   value: job.id,
    //         // }));

    //         // setJobList(options);
    //         // return options;


    //         //
    //         const options = allOptions.map(tool => ({
    //             label: tool.name,
    //             value: tool.id,
    //         }));
    //         setToolsList(options)
    //         return options

    //     } catch (error) {
    //         console.error('Помилка завантаження інструментів:', error);
    //         setToolsList([]);
    //         return [];
    //     }
    // };

    //Додавання інструмента ()
    // const addTool = async (id) => {
    //     console.log('CLICK', id)
    //     const exists = jobTools.some(tool => {
    //         return tool.jobToolList.id === id

    //     })

    //     if (exists) {
    //         toast.warn("Такий інструмент вже додано!");
    //         return;
    //     }
    //     try {
    //         const response = await AxiosInstance.post(`/job_tools`, {
    //             jobToolList: `/api/job_tools_lists/${id}`,
    //             job: `/api/jobs/${dataState.id}`,
    //             status: "send-to-verify"

    //         });

    //         console.log('response.data', response.data)
    //         // workerProfessionsList()
    //         jobToolsList()
    //         toast.success('Інструмент успішно доданий')

    //     } catch (error) {
    //         console.error("Помилка:", error);
    //     }
    // };



    //оновлена версія функціі без статичного списка інструментів
    const addTool = async (contragentId) => {

        if (toolName === '' || toolNumber === '') return

        //Перевірка по серійному номеру
        const exists = jobTools.some(tool => tool.jobToolList.seriesNumber === toolNumber);
        if (exists) {
            toast.warn("Інструмент з таким серійним номером вже додано до цієї роботи!");
            return;
        }

        try {

            //Отримуємо найсвіжіший список інструментів акаунта
            const response = await AxiosInstance.get(`/job_tools_lists`);
            const allTools = response.data['hydra:member'] || [];

            // Фільтруємо лише ті, що належать цьому акаунту
            const contragentTools = allTools.filter(
                (tool) => tool.account.id === contragentId
                // `/api/accounts/${contragentId}`
            );
            setToolsList(contragentTools)

            // Перевірка на дублікати в актуальному списку акаунта-робим через find ,треба отримати інструмент

            // const existsInContragentList = contragentTools.some(
            //     (tool) => tool.seriesNumber === toolNumber
            // );

            // if (existsInContragentList) {
            //     toast.warn("Інструмент з таким серійним номером вже існує у цього контрагента!");
            //     return;
            // }


            const existingTool = contragentTools.find(
                (tool) => tool.seriesNumber === toolNumber
            );

            //умовний блок в залежності від того чи існує інструмент у контрагента
            if (existingTool) {
                //  Якщо знайдений — додаємо його до job_tools
                let toolListId = existingTool['@id'];
                console.log("Інструмент вже існує у контрагента:", existingTool);

                //  POST в job_tools, щоб прив'язати до поточної роботи
                const addToolResponse = await AxiosInstance.post(`/job_tools`, {
                    jobToolList: toolListId,
                    job: `/api/jobs/${dataState.id}`,
                    status: "send-to-verify",
                });
                toast.success("Додано до job_tools існуючий інструмент:", addToolResponse.data);

                setToolName('')
                setToolNumber('')

                //Оновлюємо список
                jobToolsList();
                contragentToolsList()

            }

            else {

                //
                //  Створюємо новий запис у job_tools_lists
                const createToolResponse = await AxiosInstance.post(`/job_tools_lists`, {
                    name: toolName,
                    account: `/api/accounts/${contragentId}`,
                    seriesNumber: toolNumber
                });

                const createdTool = createToolResponse.data;
                console.log("Створено job_tool_list:", createdTool);

                //  Додаємо цей інструмент до job_tools
                const addToolResponse = await AxiosInstance.post(`/job_tools`, {
                    jobToolList: createdTool['@id'],
                    job: `/api/jobs/${dataState.id}`,
                    status: "send-to-verify"
                });

                console.log("Додано до job_tools:", addToolResponse.data);
                toast.success("Інструмент успішно доданий!");
                setToolName('')
                setToolNumber('')

                //Оновлюємо список
                jobToolsList();
                contragentToolsList()

            }

        } catch (error) {
            console.error("Помилка при додаванні інструмента:", error);
            toast.error("Помилка при додаванні інструмента!");
        }
    };




    //БЛОК ЗМІНИ СТАТУСА ДОКУМЕНТА ДЛЯ АДМІНА

    //зміна статуса на підтверджено verified
    async function adminConfirmToSuccess(id) {
        try {
            await confirmAlert({
                title: 'Увага',
                message: 'Ви впевнені що хочете підтвердити інструмент ?',
                buttons: [
                    {
                        label: 'Так',
                        onClick: async () => changeStatusToSuccess(id)
                    },
                    {
                        label: 'Ні',
                        onClick: () => {
                            return
                        },
                    },
                ],
            })
        } catch (error) {
            console.error('Помилка видалення:', error)
        }

    }

    async function changeStatusToSuccess(id) {
        const docData = {
            status: 'verified',
            dateConfirm: new Date().toISOString(),
            userComfirmDescription: coment[id] || ''
        }

        try {
            const response = await AxiosInstance.put(`${toolsUrl}/${id}`, docData, header);
            toast.success('Інструмент підтверджено')
            // workerProfessionsList()
            jobToolsList()
            setComent(prev => {
                const newComent = { ...prev };
                delete newComent[id];
                return newComent;
            })
            return response.data;
        } catch (error) {
            console.error('Помилка при зміні статуса:', error);
            throw error;
        }
    }

    //зміна статуса на rejected
    async function adminConfirmToRejected(id) {

        try {
            await confirmAlert({
                title: 'Увага',
                message: 'Ви впевнені що хочете відхилити інструмент ?',
                buttons: [
                    {
                        label: 'Так',
                        onClick: async () => changeStatusToRejected(id)
                    },
                    {
                        label: 'Ні',
                        onClick: () => {
                            return
                        },
                    },
                ],
            })
        } catch (error) {
            console.error('Помилка видалення:', error)
        }

    }

    async function changeStatusToRejected(id) {
        const docData = {
            status: 'rejected',
            userComfirmDescription: coment[id] || ''
        }

        try {
            const response = await AxiosInstance.put(`${toolsUrl}/${id}`, docData, header);
            toast.success('Інструмент відхилено')
            // workerProfessionsList()
            jobToolsList()
            setComent(prev => {
                const newComent = { ...prev };
                delete newComent[id];
                return newComent;
            })
            return response.data;
        } catch (error) {
            console.error('Помилка при зміні статуса:', error);
            throw error;
        }
    }

    //БЛОК ЗМІНИ СТАТУСА ДЛЯ ПАРТНЕРА
    //зміна статуса на send-to-verify +

    async function partnerConfirmToSendToVerify(id) {
        try {
            await confirmAlert({
                title: 'Увага',
                message: 'Ви впевнені що хочете відправити інструмент на перевірку ?',
                buttons: [
                    {
                        label: 'Так',
                        onClick: async () => changeStatusToSendToVerify(id)
                    },
                    {
                        label: 'Ні',
                        onClick: () => {
                            return
                        },
                    },
                ],
            })
        } catch (error) {
            console.error('Помилка видалення:', error)
        }

    }

    async function changeStatusToSendToVerify(id) {
        const docData = {
            status: 'send-to-verify'
        }

        try {
            const response = await AxiosInstance.put(`${toolsUrl}/${id}`, docData, header);
            toast.success('Інструмент відправлено на перевірку')
            // workerProfessionsList()
            jobToolsList()
            return response.data;
        } catch (error) {
            console.error('Помилка при зміні статуса:', error);
            throw error;
        }
    }

    //зміна стану для коменту

    function handleComentChange(id, value) {
        setComent(
            prev => {
                return ({ ...prev, [id]: value })
            }
        )
    }



    //Ефект для завантаження списку інструментів
    useEffect(() => {
        jobToolsList()
        // loadToolsOptions();
        contragentToolsList()
    }, [])

    // блок пошуку
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (toolName) {
                    let response;
                    response = await AxiosInstance.get(
                        `/job_tools_lists?name=${toolName}&account.id=${dataState.account.id}`)
                    // console.log("AUDIT", response.data["hydra:member"]);

                    setSearchResults(response.data["hydra:member"]);
                    setShowResults(true);
                    // показуємо результати після отримання даних
                }
            } catch (error) {
                console.error("Error:", error);
            }
        };

        const delayDebounceFn = setTimeout(() => {
            fetchData();
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [toolName]);


    //клік по результату
    const handleResultClick = (name, number) => {
        // console.log("AUDIT", id, name);

        // setSearchProductId(id);
        // setSearchInput(name);
        setToolName(name)
        setToolNumber(number)

        setShowResults(false);
    };

    // hide results on blur
    const handleInputBlur = () => {
        setTimeout(() => {
            setShowResults(false);
        }, 300);
    };





    // Друк посвідчень усіх працівників заявки в один клік.
    // Використовує прихований iframe щоб уникнути блокування popup'ів браузером.
    // Дані беруться з printWorkersData (завантажено в JobWorkers.jsx через setPrintWorkersData).
    const printAllWorkers = () => {
        // Фільтруємо з усіх workers акаунту лише тих, хто є в поточній заявці
        const workerIds = jobWorkers.map((jw) => jw.worker.id);
        const workers = printWorkersData.filter((w) => workerIds.includes(w.id));
        if (workers.length === 0) return;

        // Створюємо прихований iframe — друк через нього не блокується браузером як popup
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);

        // Записуємо HTML-каркас в iframe: підключаємо стилі карток і задаємо flex-wrap для розміщення декількох карток на сторінці.
        // @page навмисно не задаємо — розмір паперу береться з налаштувань принтера
        const iframeDoc = iframe.contentDocument;
        iframeDoc.open();
        iframeDoc.write(`<html><head>
            <title>Посвідчення</title>
            <link rel="stylesheet" href="/css/print-worker.css" />
            <style>
                body { margin: 0; padding: 0; }
                #print-root { display: flex; flex-wrap: wrap; row-gap: 20mm; column-gap: 5mm; }
                .print-card { break-inside: avoid; page-break-inside: avoid; }
            </style>
        </head><body><div id="print-root"></div></body></html>`);
        iframeDoc.close();

        // Рендеримо всі картки через ReactDOM.createRoot в iframe.
        // selectedOption передає назву контрагента — як в одиночному друці WorkerModalV1.js
        const selectedOption = { label: dataState?.account?.name || '' };
        const root = ReactDOM.createRoot(iframeDoc.getElementById('print-root'));
        root.render(
            <>
                {workers.map((worker) => {
                    // Сортуємо професії: підтверджені (workerProffesionDocs[last].status === 'verified') йдуть першими.
                    // Логіка ідентична одиночному друку в WorkerModalV1.js
                    const sorted = [...(worker.workerProffessions || [])].sort((a, b) => {
                        const aVerified = a.workerProffesionDocs?.length > 0 &&
                            a.workerProffesionDocs[a.workerProffesionDocs.length - 1].status === 'verified';
                        const bVerified = b.workerProffesionDocs?.length > 0 &&
                            b.workerProffesionDocs[b.workerProffesionDocs.length - 1].status === 'verified';
                        if (aVerified && !bVerified) return -1;
                        if (!aVerified && bVerified) return 1;
                        return 0;
                    });
                    return (
                        <PrintWorkerCard
                            key={worker.id}
                            dataState={worker}
                            sortedProfessions={sorted}
                            selectedOption={selectedOption}
                        />
                    );
                })}
            </>
        );

        // Прибираємо iframe після закриття діалогу друку.
        // cleaned — захист від подвійного виклику (onafterprint + setTimeout можуть спрацювати обидва)
        let cleaned = false;
        const cleanup = () => {
            if (cleaned) return;
            cleaned = true;
            root.unmount();
            document.body.removeChild(iframe);
        };
        iframe.contentWindow.onafterprint = cleanup;
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            setTimeout(cleanup, 2000);
        };
    };

    // console.log('toolsList', toolsList)
    // console.log('dataState', dataState)
    // console.log('jobTools', jobTools)
    // console.log('printWorkersData', printWorkersData)


    return (
        <>
            {/* Модальне вікно з попередженням */}
            <WarningWhenChecked
                openWarning={openWarning}
                handleCloseWarning={handleCloseWarning}
                changeStatus={changeStatus}
                userRoleForWarningModal={userRoleForWarningModal}
                jobName={dataState.name}
            />

            {/* <CForm onSubmit={handleSubmitAddFile} className="mb-3"> */}


            {/* isDisabledAll={true} - Заблокувати можливу зміну */}
            {
                !isDisabledAll &&
                <>
                    {/* Блок кнопок */}
                    <ButtonsBlock
                        dataState={dataState} role={props.role}
                        isDisabledChange={isDisabledChange} isSendForInspection={isSendForInspection}
                        isDisabledSend={isDisabledSend}
                        changeStatus={changeStatus} addComentar={addComentar}
                        comentar={comentar}
                        setOpenWarningForEngineer={setOpenWarningForEngineer}
                        setOpenWarningForMainEngineerOp={setOpenWarningForMainEngineerOp}
                        isMainEngineerOp={props.isMainEngineerOp}
                    />

                    {/* Текстове поле з зауваженнями до файлів */}
                    <>
                        {
                            (
                                (dataState?.comentar !== undefined && dataState?.comentar !== "" && dataState?.status !== "synced" && dataState?.status !== "checked") ||
                                (props.role === "ROLE_ADMIN" && dataState?.status !== "checked" && dataState?.status !== "new" && dataState?.status !== "synced")
                            ) &&
                            <CFormTextarea
                                className='mt-3'
                                id="floatingTextarea"
                                floatingLabel="Зауваження від адміністратора"
                                placeholder="Leave a comment here"
                                // style={{ height: '100px' }}
                                value={comentar}
                                onChange={(e) => setComentar(e.target.value)}
                                disabled={(props.role !== "ROLE_ADMIN" || !(dataState?.status === "not_checked"))}
                            ></CFormTextarea>
                        }
                    </>

                    <hr />
                </>
            }


            {/* Загальні дані про роботу */}
            <JobData
                data={dataState}
                handleSubmit={props.handleSubmit}
                loadOptionsFactories={props.loadOptionsFactories}
                selectedOptionFactories={props.selectedOptionFactories}
                handleChangeFactories={props.handleChangeFactories}
                selectedOptionEngineers={props.selectedOptionEngineers}
                selectedEngineer={props.selectedEngineer}
                handleChangeEngineers={props.handleChangeEngineers}
                cancelChange={props.cancelChange}
                isDisabledAll={isDisabledAll}
                isDisabledChange={isDisabledChange}
            />

            <hr />



            <CForm onSubmit={handleSubmitAddFile} className="mb-3">

                <Tabs>
                    <TabList>
                        <Tab>
                            <FaUserCog className="nav-icon" />{/*  */}
                            <span style={{ marginLeft: '5px' }}>Працівники</span>
                        </Tab>
                        <Tab

                        > <MdWarningAmber className="nav-icon" />
                            <span style={{ marginLeft: '2px' }}> Роботи високої небезпеки</span>
                        </Tab>
                        <Tab > <FaTractor className="nav-icon" />
                            <span style={{ marginLeft: '5px' }}>Спецтехніка</span>
                        </Tab>
                        <Tab style={{ width: '80px', textAlign: 'center' }}>
                            <FaHardHat className="nav-icon" />
                            <span style={{ marginLeft: '5px' }}>ОП</span>
                        </Tab>
                        {/* <Tab>
                            <FaBoxes className="nav-icon" />
                            <span style={{ marginLeft: '5px' }}> Матеріали</span>
                        </Tab> */}
                        {/* <Tab>
                            <FaTools className="nav-icon" />
                            <span style={{ marginLeft: '5px' }}>Інструменти</span>
                        </Tab> */}
                    </TabList>

                    {/* Працівники */}
                    <TabPanel>
                        <div className="mb-5">
                            <JobWorkers
                                data={props.data}
                                getData={getData}
                                jobWorkers={jobWorkers}
                                popup={props.popup}
                                setPrintWorkersData={setPrintWorkersData}
                                isDisabledAll={isDisabledAll}
                                isDisabledChange={isDisabledChange}
                                role={props.role}
                            />
                        </div>
                        {(dataState?.status === 'checked' || dataState?.status === 'synced') &&
                            <CButton color="secondary" onClick={printAllWorkers} className="mt-2">
                                Надрукувати посвідчення
                            </CButton>
                        }
                        {/* <hr /> */}
                    </TabPanel>

                    <TabPanel>
                        <div className="mb-3">
                            <CFormCheck
                                id="flexCheckDefault"
                                label="Будуть виконуватись роботи підвищеної небезпеки"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                disabled={isDisabledAll || isDisabledChange}
                            />
                        </div>

                        {/* Роботи підвищеної небезпеки */}
                        <div>
                            {
                                isChecked &&
                                <DangerWorks
                                    data={props.data}
                                    accJobsList={accJobsList}
                                    getData={getData}
                                    isDisabledAll={isDisabledAll}
                                    isDisabledChange={isDisabledChange}
                                    popup={props.popup}
                                />
                            }
                        </div>

                        {/* <hr /> */}
                    </TabPanel>


                    {/* Спецтехніка */}
                    <TabPanel>
                        <div className="mb-5">
                            <JobSpecialMachines
                                data={props.data}
                                jobId={props.data.id}
                                // getData={getData}
                                // jobSpecialMachines={jobSpecialMachines}
                                popup={props.popup}
                                isDisabledAll={isDisabledAll}
                                isDisabledChange={isDisabledChange}
                                role={props.role}
                                // jobWorkers={props.data.jobWorkers}
                                jobWorkers={jobWorkers}

                            />
                        </div>

                        {/* <hr /> */}
                    </TabPanel>
                    {/* <div className='d-flex gap-5'> */}
                    {/* <div> */}
                    <TabPanel>
                        {/* Про відповідального за Охорону праці */}
                        <ResponsibleForLaborProtection
                            handleFileChangeState={handleFileChangeState}
                            setCommandmentState={setCommandmentState}
                            disabledChange={isDisabledChange}
                            handleAddFile={handleAddFile}
                            commandmentState={commandmentState}
                            urlApi={urlApi}
                            myDataState={myDataState}
                            css={props.css}
                            deleteFile={deleteFile}
                            isDisabledAll={isDisabledAll}
                        />

                        {/* Графік виконання робіт */}
                        <WorkSchedule
                            handleFileChangeState={handleFileChangeState}
                            setGraphState={setGraphState}
                            disabledChange={isDisabledChange}
                            handleAddFile={handleAddFile}
                            graphState={graphState}
                            urlApi={urlApi}
                            myDataState={myDataState}
                            css={props.css}
                            deleteFile={deleteFile}
                            isDisabledAll={isDisabledAll}
                        />

                        {/* Протоколи перевірки знань з ОП */}
                        <ProtocolOP
                            handleFileChangeState={handleFileChangeState}
                            setProtocoleState={setProtocoleState}
                            disabledChange={isDisabledChange}
                            handleAddFile={handleAddFile}
                            protocoleState={protocoleState}
                            urlApi={urlApi}
                            myDataState={myDataState}
                            css={props.css}
                            deleteFile={deleteFile}
                            isDisabledAll={isDisabledAll}
                        />
                    </TabPanel>
                    {/* <hr /> */}

                    {/* <TabPanel>
                       // Додаткові матеіали 
                        <AdditionalMaterials
                            handleFileChangeState={handleFileChangeState}
                            setFile={setFile} file={file}
                            css={props.css}
                            arrFile={arrFile}
                            deleteFile={deleteFile}
                            isDisabledAll={isDisabledAll}
                            isDisabledChange={isDisabledChange}

                        />
                    </TabPanel> */}

                    {/* <TabPanel>
                        //Додаткові інструменти
                        <AdditionalInstruments
                            blocks={blocks}
                            toolsList={toolsList}
                            // loadToolsOptions={loadToolsOptions}
                            jobTools={jobTools}
                            selectedTool={selectedTool}
                            setSelectedTool={setSelectedTool}
                            addTool={addTool}
                            role={role}
                            adminConfirmToSuccess={adminConfirmToSuccess}
                            adminConfirmToRejected={adminConfirmToRejected}
                            partnerConfirmToSendToVerify={partnerConfirmToSendToVerify}
                            handleComentChange={handleComentChange}
                            toolName={toolName}
                            setToolName={setToolName}
                            toolNumber={toolNumber}
                            setToolNumber={setToolNumber}
                            dataState={dataState}

                            searchResults={searchResults}
                            setSearchResults={setSearchResults}
                            showResults={showResults}
                            setShowResults={setShowResults}
                            handleResultClick={handleResultClick}
                            handleInputBlur={handleInputBlur}

                        />
                    </TabPanel> */}
                    {/* </div> */}
                </Tabs>
                {/* кінець табів */}


                {/* isDisabledAll={true} - Заблокувати можливу зміну */}
                {
                    !isDisabledAll &&
                    <>
                        <hr />

                        {/* Блок кнопок */}
                        <ButtonsBlock
                            dataState={dataState} role={props.role}
                            isDisabledChange={isDisabledChange} isSendForInspection={isSendForInspection}
                            isDisabledSend={isDisabledSend}
                            changeStatus={changeStatus} addComentar={addComentar}
                            comentar={comentar}
                            setOpenWarningForEngineer={setOpenWarningForEngineer}
                            setOpenWarningForMainEngineerOp={setOpenWarningForMainEngineerOp}
                            isMainEngineerOp={props.isMainEngineerOp}
                        />

                    </>
                }

            </CForm >
        </>
    );
};

export default ExistJobForm;